<template>
  <div class="profile">
    <div class="container">
      <div class="profile__wrapper">
        <div class="profile__left">
          <h1 class="profile__title">{{ t('profile.title') }}</h1>
          <nav class="profile__nav">
            <router-link
                :to="translations.i18nRoute({ name: 'profile-dashboard' })"
                :class="[{ active: route.name === 'profile-dashboard' }]"
            >
              {{ t('header.burger.dashboard') }}
            </router-link>
            <router-link
                :to="translations.i18nRoute({ name: 'profile-orders' })"
                :class="[{ active: route.name === 'profile-orders' }]"
            >
              {{ t('header.burger.orders') }}
            </router-link>
            <router-link
                :to="translations.i18nRoute({ name: 'profile-details' })"
                :class="[{ active: route.name === 'profile-details' }]"
            >
              {{ t('header.burger.accountDetails') }}
            </router-link>
            <router-link
                :to="translations.i18nRoute({ name: 'profile-wishlist' })"
                :class="[{ active: route.name === 'profile-wishlist' }]"
            >
              {{ t('header.burger.wishlist') }}
            </router-link>
            <router-link
                :to="translations.i18nRoute({ name: 'profile-cart' })"
                :class="[{ active: route.name === 'profile-cart' }]"
            >
              {{ t('header.burger.cart') }}
            </router-link>
            <p @click="logout">{{ t('header.burger.logOut') }}</p>
          </nav>
        </div>
        <div class="profile__main">
          <RouterView v-slot="{ Component }">
            <Transition name="opacity" mode="out-in">
              <component :is="Component" />
            </Transition>
          </RouterView>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import translations from "@/core/helpers/translations.js";
import {useRoute, useRouter} from "vue-router";
import {useAuthStore} from "@/stores/auth.js";

const {t} = useI18n()
const route = useRoute()
const router = useRouter()
const authStore = useAuthStore()

const logout = async () => {
  authStore.setUser({
    user: null,
    accessToken: null
  })

  localStorage.removeItem('ngs-refresh')
  localStorage.removeItem('ngs-remember')
  localStorage.removeItem('ngs-login')

  await router.push({
    name: 'home',
    params: {
      locale: localStorage.getItem('ngs-user-locale') || 'en-gb'
    }
  })
}
</script>

<style lang="scss" scoped>
.profile {
  padding-block: 60px 100px;

  &__wrapper {
    display: flex;
    align-items: flex-start;
    gap: 30px;
  }

  &__left {
    width: 250px;
    border-right: 1px solid #E4E4E4;
    padding-right: 30px;
  }

  &__title {
    border-bottom: 1px solid #E4E4E4;
    padding-inline: 10px;
    padding-bottom: 5px;
    color: #2F2F2F;
    font-size: 18px;
    font-weight: 600;
    line-height: 30.8px;
    text-transform: uppercase;
  }

  &__nav {
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding-top: 15px;

    & a, p {
      cursor: pointer;
      transition: 0.1s;
      border-radius: 10px;
      background-color: transparent;
      padding: 10px 15px;

      color: #2F2F2F;
      font-size: 14px;
      font-weight: 700;
      line-height: 25.6px;

      @include hover {
        background-color: #F1F1F1;
      }

      &.active {
        background-color: #F1F1F1;
      }
    }
  }

  &__main {
    width: 100%;
  }
}

@media (max-width: 600px) {
  .profile {
    &__wrapper {
      gap: 15px;
    }

    &__title {
      font-size: 14px;
      line-height: 18px;
    }

    &__left {
      width: fit-content;
      padding-right: 15px;
    }

    &__nav {
      & a, p {
        padding: 5px 7px;
        font-size: 12px;
      }
    }
  }
}
</style>